import NewsletterSixteenContainer from "./containers/NewsletterSixteenContainer";
export default NewsletterSixteenContainer;
